import React, { forwardRef } from 'react';
import ScheduleValue from '../../components/ScheduleValue';

/**
 * Component for displaying schedule items
 * @param {Object} props - Component props
 * @param {string} props.sectionTitle - Title of the schedule section
 * @param {Array} props.scheduleItems - Array of schedule items
 * @param {number|null} props.currentIndex - Index of the current item (for highlighting)
 * @param {boolean} [props.isUpcoming=false] - Whether this is an upcoming schedule section
 */
const ScheduleSection = forwardRef(({ sectionTitle, scheduleItems, currentIndex, isUpcoming = false }, ref) => {
  const sectionClass = isUpcoming ? "upcoming-schedule" : "service-schedule";

  return (
    <section className={sectionClass} ref={ref}>
      <div className="schedule-section">
        <h2 className="hebrew-heading">{sectionTitle}</h2>
        <div className="schedule-content">
          {scheduleItems
            .filter(item => !item.hideItem && item.display !== 'print_only' && item.display !== 'none')
            .map((item, idx) => {
              const itemClass = !isUpcoming && idx === currentIndex 
                ? "schedule-item current" 
                : "schedule-item";
              
              return (
                <div key={idx} className={itemClass}>
                  <div className="schedule-title-container">
                    <strong className="schedule-title">{item.title}</strong>
                    {item.byline && (
                      <div className="schedule-byline">
                        {item.byline}
                      </div>
                    )}
                  </div>
                  <ScheduleValue
                    className="schedule-value"
                    value={item.value}
                    fontSize={item.fontSize}
                    isCurrent={!isUpcoming && idx === currentIndex}
                    suppressHydrationWarning
                  />
                </div>
              );
            })}
        </div>
      </div>
    </section>
  );
});

ScheduleSection.displayName = 'ScheduleSection';

export default ScheduleSection;
